import { getMapStateToRequestStatusProps } from "./logic/logic";
import { mapStateToErrorRequestStatusProps } from "./components/TechnicalError";
import { mapStateToPaymentErrorRequestStatusProps } from "./components/PaymentError";
import { mapStateToProcessingRequestStatusProps } from "./components/Processing";
import { mapStateToSuccessRequestStatusProps } from "./components/Success";
import { RequestStatusRedesign } from "./RequestStatusRedesign";
import { mapStateToCheckSmsCodeMaxAttemptsRequestStatusProps } from "./components/CheckSmsCodeMaxAttempts";
import { mapStateToSendSmsCodeMaxAttemptsRequestStatusProps } from "./components/SendSmsCodeMaxAttempts";
import { mapStateToSmsCodeExpiredRequestStatusProps } from "./components/SmsCodeExpired";

/**
 * Для обратной совместимости
 * можно просто поменять ReuestStatusRedsign на RequestStatus из @beef/smart-kit
 */
export var RequestStatus = RequestStatusRedesign;

/**
 * Set up dependencies for the request status (popup) state mapping.
 *
 * NOTE: Index files are responsible for connecting dependencies to their respective logic
 * This approach uses a hierarchical composition pattern, where dependencies are organized
 * at the same level as their corresponding components. This keeps the codebase modular
 * and easier to maintain.
 * The top-level index.ts file gathers dependencies from the index.ts files of other components
 * and composes them following the same hierarchy as the components.
 * */
export var mapStateToRequestStatusProps = getMapStateToRequestStatusProps({
  mapStateToErrorRequestStatusProps: mapStateToErrorRequestStatusProps,
  mapStateToPaymentErrorRequestStatusProps: mapStateToPaymentErrorRequestStatusProps,
  mapStateToProcessingRequestStatusProps: mapStateToProcessingRequestStatusProps,
  mapStateToSuccessRequestStatusProps: mapStateToSuccessRequestStatusProps,
  mapStateToCheckSmsCodeMaxAttemptsRequestStatusProps: mapStateToCheckSmsCodeMaxAttemptsRequestStatusProps,
  mapStateToSendSmsCodeMaxAttemptsRequestStatusProps: mapStateToSendSmsCodeMaxAttemptsRequestStatusProps,
  mapStateToSmsCodeExpiredRequestStatusProps: mapStateToSmsCodeExpiredRequestStatusProps
});